import { useEffect, useMemo, useState } from 'react'
import { Modal } from 'stories/components'
import { RenderInput } from 'utils/RenderInput'

import { bankAccountInputs } from './constants'
import { type IBankAccount, emptyBankAccount } from './types'

export const EditBankAccountDialog = ({
  item,
  onClose,
  onSave,
}: {
  item: Partial<IBankAccount> | null
  onClose: () => void
  onSave: (data: Partial<IBankAccount>) => Promise<void>
}) => {
  const [form, setForm] = useState<Partial<IBankAccount>>(emptyBankAccount())
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!item) return
    setForm({ ...item })
  }, [item])

  const inputs = useMemo(() => bankAccountInputs(form), [form])

  if (!item) return null

  const onChange = (key: string, value: any) => {
    setForm((prev) => ({ ...prev, [key]: value }))
  }

  const onSubmit = async () => {
    setSaving(true)
    try {
      await onSave({
        name: form.name,
        glAccountNo: form.glAccountNo,
        type: form.type,
      })
      onClose()
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal
      isOpen
      title={item.id ? 'Edit Bank Account' : 'Add Bank Account'}
      loading={saving}
      disabled={!form.name?.trim() || !form.glAccountNo?.trim()}
      onOk={onSubmit}
      onClose={onClose}
      titleOkay="Save"
      titleCancel=""
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-2">
        {Object.keys(inputs).map((key) => (
          <RenderInput key={key} input={inputs[key]} Key={key} onChange={onChange} />
        ))}
      </div>
    </Modal>
  )
}
